import styled from 'styled-components';

export const SurveyStyle = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  .survey-form {
    &-input {
      width: 100%;
    }
    &-textarea {
    }
  }

  .input-range {
    margin: 0 12px;
  }

  .survey-title {
    margin-bottom: 24px;
    /* display: flex; */
    align-items: center;
    &__button {
      width: 42px;
      margin-bottom: 12px;
    }
  }

  form button {
    background-color: ${(props) => props.theme.primary.primary50};
    padding: 18px;
    width: 100%;
    border: none;
    outline: none;
    color: white;
    border-radius: 6px;
    cursor: pointer;
  }

  .survey-send-btn {
    margin-top: 20px;
  }
  .arrow-back {
    z-index: 9;
    position: absolute;
    top: 0;
    left: 15px;
  }
`;

export const TextareaContainer = styled.div`
  position: relative;

  textarea {
    resize: none;
    width: 100%;
    height: 140px;
    outline: none;
    border: 1px solid lightgrey;
    border-radius: 6px;
    padding: 16px 12px;
    font-size: 16px;
    line-height: 1.2;

    &::placeholder {
      color: #62656a;
      opacity: 1;
    }
    &:-ms-input-placeholder {
      color: #62656a;
    }

    &::-ms-input-placeholder {
      color: #62656a;
    }
  }

  .char-count {
    position: absolute;
    bottom: 16px;
    right: 12px;
    color: #cfd3d7;
    user-select: none;
  }
`;
